// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7COdF","question":"styles_question__JTfBq","description":"styles_description__1quz9"};